import { forwardRef } from 'react';
import Sections, { SectionsData } from '../../form-elements/Sections';
import type { FieldProps } from '@rjsf/utils';

const SectionsField = forwardRef<HTMLDivElement, FieldProps<SectionsData>>((props, ref) => {
  const {
    formData,
    onChange,
    schema,
    fieldPathId: { path },
  } = props;

  return (
    <div ref={ref}>
      <Sections value={formData} title={schema.title} onChange={(value) => onChange(value, path)} />
    </div>
  );
});

SectionsField.displayName = 'SectionsField';

export default SectionsField;
